import React from 'react';
import Pusher from 'pusher-js';
import * as action from 'actions';
import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import {
  pageRequest,
  doneExportSummary,
  errorExportSummary,
} from 'actions/inventory/summary';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import NoDataAndLoading from 'components/NoDataAndLoading';
import { PUSHER_APP_KEY } from 'api/constants';
import ListSummaryIngredients from './ListSummaryIngredients';
import List from './List';
import ActionBar from './ActionBar';

class Summary extends React.Component {
  render() {
    const { showLoadingSpinnerPage, search, items, ingredients } = this.props;
    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={
                search && search.namespace !== 'ingredients'
                  ? items.length === 0
                  : ingredients.length === 0
              }
              title="No Data To Display"
              description=""
              linkLabel="Upload Beginning Inventory Using Bulk Import"
              linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/900000397123-Cara-Melihat-Ringkasan-Stok-Barang-dan-Bahan-Baku"
            />
            {search && search.namespace !== 'ingredients' ? (
              <List />
            ) : (
              <ListSummaryIngredients />
            )}
          </LeftColumnWrapper>
          <RightColumnWrapper />
        </ContentWrapper>
      </PageWrapper>
    );
  }

  componentDidMount() {
    const { dispatch, id } = this.props;

    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
      encrypted: true,
    });

    this.channel = pusher.subscribe(`moka-${id}-inventory`);

    dispatch(pageRequest());
  }

  componentDidUpdate() {
    const { dispatch, idAsyncJob } = this.props;

    this.channel.bind('library/summary-item/export', data => {
      if (
        idAsyncJob &&
        data.resource_id &&
        idAsyncJob.async_job_id === data.resource_id &&
        data.type === 'export-done'
      ) {
        dispatch(doneExportSummary());
        dispatch(action.showLoadingSpinner(false));
        window.location.href = data.url_path;
      } else if (
        idAsyncJob &&
        data.resource_id &&
        idAsyncJob.async_job_id === data.resource_id &&
        !data.success
      ) {
        dispatch(errorExportSummary(data));
      }
    });

    this.channel.bind('library/summary-ingredient/export', data => {
      if (
        idAsyncJob &&
        data.resource_id &&
        idAsyncJob.async_job_id === data.resource_id &&
        data.type === 'export-done'
      ) {
        dispatch(doneExportSummary());
        dispatch(action.showLoadingSpinner(false));
        window.location.href = data.url_path;
      } else if (
        idAsyncJob &&
        data.resource_id &&
        idAsyncJob.async_job_id === data.resource_id &&
        !data.success
      ) {
        dispatch(errorExportSummary(data));
      }
    });
  }
}

function mapStateToProps(state) {
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  const { id } = state.moka.user.business;
  const {
    items,
    ingredients,
    isExportLoading,
    idAsyncJob,
  } = state.inventory.summary;
  return {
    showLoadingSpinnerPage,
    search: getFormValues('search')(state),
    items,
    ingredients,
    isExportLoading,
    idAsyncJob,
    id,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Summary);
